import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const ContentHolder = (props) => {
  const { children, style } = props

  return (
    <div className={styles.root} style={style}>
      {children}
    </div>
  )
}

ContentHolder.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
}

export default ContentHolder
